(function () {
  var container = document.getElementById('Details-menu-drawer-container');
  if (!container) return;

  function forceOpen(details) {
    if (!details.hasAttribute('open')) details.setAttribute('open', '');
  }

  var itemDetails = container.querySelectorAll('[id^="Details-menu-drawer-menu-item-"]');

  itemDetails.forEach(function (details) {
    forceOpen(details);
    var summary = details.querySelector('summary');
    if (!summary) return;
    // Categories are permanently expanded in the mobile drawer; block the
    // native details/summary toggle so tapping the row doesn't collapse it.
    summary.addEventListener('click', function (event) {
      event.preventDefault();
    });
  });

  container.addEventListener('toggle', function () {
    if (!container.open) return;
    itemDetails.forEach(forceOpen);
  });
})();
